import React, { Component } from "react";
import Content from "../../../content/Content";
import secondaryBlueStyles from "../../../assets/css/modules/shared/buttons/secondary-blue-button.css";
import primaryOrangeStyles from "../../../assets/css/modules/shared/buttons/primary-orange-button.css";
import secondaryOrangeStyles from "../../../assets/css/modules/shared/buttons/secondary-orange-button.css";
import primaryBlueStyles from "../../../assets/css/modules/shared/buttons/primary-blue-button.css";
import transversalStyles from "../../../assets/css/modules/shared/buttons/transversal-button.css";
import commonButtonStyles from "../../../assets/css/modules/shared/buttons/button.css";
import popoutblue from "../../../assets/img/msk/popoutblue.png";
import popout from "../../../assets/img/msk/popout.png";
import popoutOrange from "../../../assets/img/msk/HolVector.png";
import { Layouts } from "../../../constants/Constants";

export default class StyledButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHover: false
        };
    }
    componentDidMount() {
        console.log('enter');
        this.setState({
            isHover: false
        });
    }

     
    render() {
        let stylesList = ["btn"];
        let sizeStylesClass;
        let styles = primaryOrangeStyles.primaryOrangeButton;
        sizeStylesClass = this.props.btntype === 'homeButton' ? "primaryHomeOrangeButton"  : this.props.Healthsupportline1 === 'Healthsupportline' ? "primaryOrangeButtonSupport": "primaryOrangeButton";
        if (this.props.buttonType === "secondaryBlueButton") {
            styles = secondaryBlueStyles.secondaryBlueButtonstyled;
            sizeStylesClass = this.props.btntype === 'homeButton'  ? "secondaryHomeBlueButton" :this.props.Healthsupportline1 === 'Healthsupportline' ? "secondaryBlueButtonSupport": "secondaryBlueButton";
        } else if (this.props.buttonType === "secondaryOrangeButton") {
            styles = secondaryOrangeStyles.secondaryOrangeButtonMSK;
            sizeStylesClass = this.props.btntype === 'homeButton'  ? "secondaryHomeOrangeButton" : this.props.Healthsupportline1 === 'Healthsupportline' ? "secondaryOrangeButtonSupport": "secondaryOrangeButton";
        } else if (this.props.buttonType === "primaryBlueButton") {
            styles = primaryBlueStyles.primaryBlueButton;
            sizeStylesClass = this.props.btntype === 'homeButton' ? "primaryHomeBlueButton" :this.props.Healthsupportline1 === 'Healthsupportline' ?  "primaryBlueButtonSupport" : "primaryBlueButton";
        } else if (this.props.buttonType === "transversalButton") {
            styles = transversalStyles.transversalButton;
            sizeStylesClass = "transversalButton";
        }
        else if (this.props.buttonType === "secondaryOrangeButtonSupportDCA" ){
            stylesList.push(commonButtonStyles.commPrefValueHolDCA);
        }

        if (this.props.selected) {
            stylesList.push(commonButtonStyles.selected);
        }
        stylesList.push(styles);
        stylesList.push(sizeStylesClass);
        stylesList.push(commonButtonStyles.button);
        if (this.props.disabled) {
            if (this.props.IsInternalView === true) {
                stylesList.push(commonButtonStyles.disabled);
            }
            else if (this.props.IsCommValueDisabled === false || this.props.IsContactValueDisabled === false) {
                if (this.props.layout ===  Layouts.MOL) {
                    stylesList.push(commonButtonStyles.commPrefValueDisabled);
                }
                else {
                    stylesList.push(commonButtonStyles.commPrefValueHolDisabled);
                }
            }
        }

        const handleMouseEnter = e => {
            this.setState({
                isHover: true
            });
        };
        const handleMouseLeave = e => {
            this.setState({
                isHover: false
            });
        };

        return (

            <button
                id={this.props.id}
                name={this.props.name}
                type={this.props.type}
                className={stylesList.join(" ")}
                onClick={this.props.onClick}
                disabled={this.props.disabled}
                aria-label={this.props["aria-label"]}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Content name={this.props.label} />&nbsp;                        
                {this.props.layout === Layouts.MOL && this.props.buttonColor === 'blue' ?
                    <img src={popout} alt={this.props.bgAlt}
                        aria-hidden={this.props.bgAlt ? undefined : true} /> :
                    this.props.layout === Layouts.MOL && this.props.buttonColor === 'White' 
                        && !this.state.isHover ?
                        <img src={popoutblue} alt={this.props.bgAlt}
                            aria-hidden={this.props.bgAlt ? undefined : true} />: 
                            this.props.layout === Layouts.MOL && this.props.buttonColor === 'White' 
                        &&  this.state.isHover ? <img src={popout} alt={this.props.bgAlt}
                            aria-hidden={this.props.bgAlt ? undefined : true} />:
                            this.props.layout === Layouts.HOL && this.props.buttonColor === 'White' 
                            && !this.state.isHover ?
                            <img src={popoutOrange} alt={this.props.bgAlt}
                                aria-hidden={this.props.bgAlt ? undefined : true} /> :
                                <img src={popout} alt={this.props.bgAlt}
                                aria-hidden={this.props.bgAlt ? undefined : true} />
                            
                           
                } 
                          
            </button>
        );
    }
}
